/** Ventilation affichage clôture — miroir des champs sessionRecap (pas de recalcul métier). */

export function roundMoneyDisplay(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

export function buildClotureTiroirBreakdown(recap) {
  const fond = roundMoneyDisplay(recap?.fondDeCaisse);
  const ventesEspecesRaw = recap?.ventesEspeces;
  const ventesEspecesKnown = ventesEspecesRaw != null && !Number.isNaN(Number(ventesEspecesRaw));
  const ventesEspeces = ventesEspecesKnown ? roundMoneyDisplay(ventesEspecesRaw) : null;
  const remboursementsEspeces = roundMoneyDisplay(recap?.remboursements?.especes ?? 0);
  const tresorerieNet = roundMoneyDisplay(recap?.tresorerie?.net ?? 0);
  const especesAttendues = roundMoneyDisplay(
    recap?.especesEnCaisse ?? recap?.totalEspeces ?? fond
  );
  return {
    fond,
    ventesEspeces,
    ventesEspecesKnown,
    remboursementsEspeces,
    tresorerieNet,
    especesAttendues,
  };
}

/** Préremplissage comptage : solde attendu négatif → 0 € physiques (écart positif + motif). */
export function suggestEspecesCompteesInput(especesAttendues) {
  const attendu = roundMoneyDisplay(especesAttendues);
  if (attendu > 0.001) return String(attendu);
  if (attendu < -0.001) return '0';
  return '';
}
